import { useState, type FormEvent } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const testimonials = [
  { name: '王小明', role: '资深韩漫读者', content: '韩漫大全真的是我用过最好的韩漫网站，资源超全，更新速度也很快，无删减版本太赞了！强烈推荐给所有韩漫爱好者。', rating: 5 },
  { name: '李悦然', role: '漫画博主', content: '自从发现了韩漫大全，我就成了忠实用户。下拉式阅读体验非常流畅，分类也很清晰，找漫画特别方便。', rating: 5 },
  { name: '张天宇', role: '二次元爱好者', content: '界面简洁好看，漫画质量高，而且真的是无删减版本！和韩国的原作一模一样，体验感满分。', rating: 5 },
  { name: '陈思婷', role: '大学生读者', content: '免费韩漫大全这个定位太棒了，对于我们学生党来说简直是福音。漫画种类多，每天都有更新，追更停不下来。', rating: 4 },
  { name: '刘子豪', role: 'IT工程师', content: '网站做得非常专业，移动端和桌面端体验都很好。下拉式阅读模式特别适合在地铁上追漫画，已经推荐给很多同事了。', rating: 5 },
  { name: '赵晓雨', role: '插画师', content: '作为业内人士，我对韩漫的画面质量很挑剔。韩漫大全的资源画质都非常高，很良心。客服响应也很快。', rating: 5 },
];

const teamMembers = [
  { name: '朴志训', role: '创始人 & CEO', description: '韩国漫画产业资深从业者，拥有十余年漫画版权运营经验，致力于将最优质的韩国漫画带给全球中文读者。' },
  { name: '林秀晶', role: '内容总监', description: '前韩国Naver Webtoon编辑，拥有敏锐的漫画选题眼光，负责平台的漫画引进和内容质量把控。' },
  { name: '金俊勉', role: '技术总监', description: '全栈工程师，拥有丰富的互联网产品开发经验，主导开发了平台的下拉式阅读系统和推荐算法。' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('loading');
    setFormMessage('');

    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('提交成功！我们会尽快与您联系。');
      form.reset();
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const body = new URLSearchParams(formData as unknown as URLSearchParams).toString();

      const res = await fetch('https://readdy.ai/api/form/d9p0n08senbniolesngg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('提交成功！我们会尽快与您联系。');
        form.reset();
      } else {
        throw new Error(parsed?.meta?.message || parsed?.message || '提交失败');
      }
    } catch (err: unknown) {
      setFormStatus('error');
      const msg = err instanceof Error ? err.message : '网络错误';
      if (msg.toLowerCase().includes('spam')) {
        setFormMessage('提交失败，请稍后重试。');
      } else {
        setFormMessage(msg || '提交失败，请稍后重试。');
      }
    }
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫大全',
    url: 'https://www.manhuadaquan.com',
    description: '韩国漫画无删减漫画下拉式免费韩漫大全',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@manhuadaquan.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'Korean'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
              关于韩漫大全
            </h1>
            <p className="text-sm text-foreground-500 mt-1">
              韩国漫画无删减下拉式免费韩漫大全
            </p>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
                品牌介绍
              </h2>
              <div className="prose prose-sm max-w-none text-foreground-600 space-y-4 leading-relaxed">
                <p>
                  <strong>韩漫大全</strong>成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为中文读者提供<strong>无删减</strong>、高质量的韩国漫画内容，让每一位韩漫爱好者都能享受到原汁原味的阅读体验。
                </p>
                <p>
                  平台采用先进的<strong>下拉式</strong>阅读技术，完美适配网页端和移动端，用户只需轻松滑动即可畅享连续不断的漫画内容。我们与韩国多家顶级漫画工作室建立了深度合作关系，确保漫画资源<strong>丰富多元</strong>，涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、耽美、恐怖等多种类型。
                </p>
                <p>
                  作为<strong>免费韩漫大全</strong>，我们始终坚持用户至上的理念，提供大量免费漫画内容，让更多人能够接触并爱上韩国漫画。我们的专业翻译团队确保<strong>更新速度快</strong>，让您在第一时间感受韩漫的独特魅力。
                </p>
                <p>
                  目前，韩漫大全已拥有超过<strong>500万活跃用户</strong>，收录<strong>20000+部优质韩漫作品</strong>，平均每周更新漫画超过<strong>1000话</strong>，是国内最具影响力的韩国漫画平台之一。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              核心团队
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {teamMembers.map((member, i) => (
                <div key={i} className="bg-background-50 border border-background-200 rounded-xl p-6 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-user-line text-2xl text-secondary-600 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900">{member.name}</h3>
                  <p className="text-xs text-primary-600 font-medium mt-1">{member.role}</p>
                  <p className="text-sm text-foreground-500 mt-3 leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 border border-background-200 rounded-xl p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, j) => (
                      <i
                        key={j}
                        className={`text-sm w-4 h-4 flex items-center justify-center ${
                          j < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 bg-background-100" id="contact">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
                联系我们
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                <div className="bg-background-50 border border-background-200 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-lg text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-500">contact@manhuadaquan.com</p>
                </div>
                <div className="bg-background-50 border border-background-200 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-customer-service-line text-lg text-accent-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
                  <p className="text-xs text-foreground-500">7×24小时在线服务</p>
                </div>
                <div className="bg-background-50 border border-background-200 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-question-answer-line text-lg text-secondary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                  <p className="text-xs text-foreground-500">bd@manhuadaquan.com</p>
                </div>
              </div>

              <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8">
                <h3 className="text-lg font-semibold text-foreground-900 mb-6">发送消息</h3>
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form=""
                  className="space-y-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        姓名 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full h-10 px-4 text-sm bg-white border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        邮箱 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full h-10 px-4 text-sm bg-white border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      主题 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      required
                      className="w-full h-10 px-4 text-sm bg-white border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入消息主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      消息内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-3 text-sm bg-white border border-background-200 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                      placeholder="请输入您的消息（最多500字）"
                    ></textarea>
                  </div>

                  <input
                    type="text"
                    name="website_alt"
                    className="field-website-alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />

                  {formStatus === 'success' && (
                    <div className="p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700">
                      <i className="ri-checkbox-circle-line w-4 h-4 inline-flex items-center justify-center mr-1"></i>
                      {formMessage}
                    </div>
                  )}
                  {formStatus === 'error' && (
                    <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
                      <i className="ri-error-warning-line w-4 h-4 inline-flex items-center justify-center mr-1"></i>
                      {formMessage}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={formStatus === 'loading'}
                    className="inline-flex items-center gap-2 px-8 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                  >
                    {formStatus === 'loading' ? (
                      <>
                        <i className="ri-loader-4-line animate-spin w-4 h-4 flex items-center justify-center"></i>
                        提交中...
                      </>
                    ) : (
                      <>
                        发送消息
                        <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center"></i>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}